// Auto generated file, do not manually modify!
// com.hotpads.customermanagement.client.eventtracking.enums.EnterpriseListingEvent

export enum EnterpriseListingEvent {
  EDIT = 'EDIT',
  VIEW_PROPERTY = 'VIEW_PROPERTY',
}

export const EnterpriseListingEvent_values = [
  EnterpriseListingEvent.EDIT,
  EnterpriseListingEvent.VIEW_PROPERTY,
] as const;
